"use client";

import * as React from "react";

import styles from "./EmptyDashboard.module.css";

export interface EmptyDashboardTemplate {
  id: string;
  name: string;
  description: string;
  audience?: string;
}

export interface EmptyDashboardProps {
  title?: string;
  subtitle?: string;
  templates?: EmptyDashboardTemplate[];
  onSelectTemplate?: (templateId: string) => void;
  onStartBlank?: () => void;
}

export function EmptyDashboard({
  title = "Start with a template",
  subtitle = "Pick a recruiter-native report to kick off, or build from scratch.",
  templates = [],
  onSelectTemplate,
  onStartBlank,
}: EmptyDashboardProps) {
  // Pre-pick a recommended template for the "Just show me one" path —
  // first template marked as recommended, otherwise the first overall.
  const recommended = templates[0];
  return (
    <div className={styles.root} role="region" aria-label="Empty dashboard">
      <div className={styles.title}>{title}</div>
      <div className={styles.subtitle}>{subtitle}</div>
      <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: 10, marginTop: 12 }}>
        {recommended && onSelectTemplate ? (
          <button
            type="button"
            onClick={() => onSelectTemplate(recommended.id)}
            className={styles.cta}
            style={{
              background: "var(--floats-product, #13319a)",
              color: "white",
              borderColor: "var(--floats-product, #13319a)",
            }}
            title={`Spawn the "${recommended.name}" template right away`}
          >
            ✨ Just show me a sample
          </button>
        ) : null}
        {onStartBlank ? (
          <button className={styles.cta} type="button" onClick={onStartBlank}>
            + Build a blank dashboard
          </button>
        ) : null}
      </div>
      {templates.length > 0 ? (
        <div className={styles.templates}>
          {templates.map((t) => (
            <button
              key={t.id}
              type="button"
              className={styles.templateCard}
              onClick={() => onSelectTemplate?.(t.id)}
            >
              <div className={styles.templateTitle}>{t.name}</div>
              <div className={styles.templateDescription}>{t.description}</div>
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
